module.exports = __webpack_public_path__ + "img/final-reward.e49fb419.png";